/**
 * Constants definition.
 *
 * @type {{PRIVATE_CNA: string, STATE_MIPYME: string, STATE_REPRESENTATIVE: string}}
 */
const PARTNER_TYPE = {
  PRIVATE_CNA: 'PRIVATE_CNA',
  STATE_MIPYME: 'STATE_MIPYME',
  STATE_REPRESENTATIVE: 'STATE_REPRESENTATIVE',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const PARTNER_TYPE_ENUM = Object.keys(PARTNER_TYPE);

const PRIVATE_CNA = PARTNER_TYPE_ENUM[0];
const STATE_MIPYME = PARTNER_TYPE_ENUM[1];
const STATE_REPRESENTATIVE = PARTNER_TYPE_ENUM[2];

export {
  PARTNER_TYPE,
  PRIVATE_CNA,
  PARTNER_TYPE_ENUM,
  STATE_MIPYME,
  STATE_REPRESENTATIVE,
};
